var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tableCommon',{ref:"tableAboutSeat",attrs:{"scrollWidth":500,"config":_vm.tableConfig,"defaultShowColumn":[],"showPagenation":false,"table-data":_vm.tableData,"table-item":_vm.tableItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }